import "./scss/global.scss";
import "swiper/css";
import { createApp } from "vue";
import { useBreakpoints } from "@vueuse/core";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Navigation, Pagination, Parallax } from "swiper";
import { ExpandTransition, FadeTransition } from "@bam/transitions";
import { OnClickOutside } from "@vueuse/components";

import * as ANIMATIONS from "./animations";

const app = createApp({
    data: () => {
        return {
            globalSwiperModules: [Autoplay, Navigation, Pagination, Parallax],
        };
    },

    mounted() {
        ANIMATIONS.initTextSlides();
        ANIMATIONS.initElementMovement();
        ANIMATIONS.initHighlightScroller();
        ANIMATIONS.initPinnedMedia();
    },
});

const bps = JSON.parse(
    getComputedStyle(document.body).getPropertyValue("--bam-breakpoints")
);
const breakpoints = useBreakpoints(bps);
app.config.globalProperties.$breakpoints = breakpoints;

const components = import.meta.globEager("./components/**/*.vue");
Object.entries(components).forEach(([path, definition]) => {
    const componentName = path
        .split("/")
        .pop()
        .replace(/\.\w+$/, "");
    app.component(componentName, definition.default);
});

app.component("expand-transition", ExpandTransition);
app.component("fade-transition", FadeTransition);
app.component("swiper", Swiper);
app.component("swiper-slide", SwiperSlide);
app.component("on-click-outside", OnClickOutside);

app.mount("#app");
